import api from './base-api';

const lobbySourcesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// ADMIN
		getLobbySources: builder.query({
			query: (lobbyId: any) => ({
				url: `/lobby-sources/lobby/${lobbyId}`,
				method: 'GET',
			}),
			providesTags: (result: any) =>
				result
					? [
							...result.map(({ id }: any) => ({ type: 'LobbySource', id })),
							{ type: 'LobbySource', id: 'LIST' },
						]
					: [{ type: 'LobbySource', id: 'LIST' }],
		}),
		createLobbySource: builder.mutation({
			query: (body: any) => ({
				url: '/lobby-sources',
				method: 'POST',
				body,
			}),
			invalidatesTags: [{ type: 'LobbySource', id: 'LIST' }],
		}),
		deleteLobbySource: builder.mutation({
			query: (id: any) => ({
				url: `/lobby-sources/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: (result: any, error: any, id: any) => [
				{ type: 'LobbySource', id },
				{ type: 'LobbySource', id: 'LIST' },
			],
		}),
	}),
	overrideExisting: false,
});

export default lobbySourcesApi;

export const {
	useGetLobbySourcesQuery,
	useCreateLobbySourceMutation,
	useDeleteLobbySourceMutation,
} = lobbySourcesApi;
